(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rutina-design"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rutina-panel')) {
    class RutinaPanel extends HTMLElement {
      connectedCallback() {
        this._connectFrame = requestAnimationFrame(() => this.mount());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this._connectFrame);
        cancelAnimationFrame(this._scrollFrame);
        this._abort?.abort();
        this._revealObserver?.disconnect();
        this._videoObserver?.disconnect();
        this._visibleObserver?.disconnect();
        this._animations?.forEach(animation => animation.cancel());
        this._mounted = false;
      }
      mount() {
        if (this._mounted || !this.isConnected) return;
        this._mounted = true;
        this._abort = new AbortController();
        this._animations = [];
        this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._desktop = window.matchMedia('(min-width: 1000px)');
        const signal = this._abort.signal;
        this._reduced.addEventListener('change', () => {
          this._animations.forEach(animation => animation.cancel());
          this.querySelectorAll('[data-rn-parallax]').forEach(node => node.style.removeProperty('transform'));
          if (this._reduced.matches) this.querySelectorAll('video').forEach(video => { video.pause(); video.controls = true; });
        }, { signal });
        this.initReveal();
        this.initParallax();
        this.initCarousel();
        this.initVideo();
      }
      initReveal() {
        if (this.dataset.rnMotion === 'false' || this._reduced.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this._revealObserver = new IntersectionObserver(entries => {
          const entering = entries.filter(entry => entry.isIntersecting);
          entering.forEach((entry, index) => {
            this._revealObserver.unobserve(entry.target);
            if (this._reduced.matches) return;
            const animation = entry.target.animate([{ opacity:0, transform:'translateY(20px)' }, { opacity:1, transform:'translateY(0)' }], { duration:720, delay:Math.min(index * 65,260), easing:'cubic-bezier(.18,.65,.25,1)', fill:'backwards' });
            this._animations.push(animation);
          });
        }, { threshold:0.08 });
        this.querySelectorAll('[data-rn-reveal]').forEach(node => this._revealObserver.observe(node));
      }
      initParallax() {
        const targets = [...this.querySelectorAll('[data-rn-parallax]')];
        if (!targets.length || this.dataset.rnMotion === 'false' || !('IntersectionObserver' in window)) return;
        let active = false;
        const update = () => {
          this._scrollFrame = null;
          if (!this._desktop.matches || this._reduced.matches) { targets.forEach(node => node.style.removeProperty('transform')); return; }
          if (!active) return;
          const rect = this.getBoundingClientRect();
          const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight + rect.height)));
          targets.forEach(node => {
            const scale = node.dataset.rnParallax === 'hero' ? 1.02 + progress * .09 : 1.055;
            node.style.transform = `translate3d(0,${((progress - .5) * 24).toFixed(2)}px,0) scale(${scale.toFixed(3)})`;
          });
        };
        const schedule = () => { if (!this._scrollFrame) this._scrollFrame = requestAnimationFrame(update); };
        this._visibleObserver = new IntersectionObserver(entries => { active = entries[0].isIntersecting; if (active) schedule(); });
        this._visibleObserver.observe(this);
        window.addEventListener('scroll', schedule, { passive:true, signal:this._abort.signal });
        window.addEventListener('resize', schedule, { passive:true, signal:this._abort.signal });
      }
      initCarousel() {
        const track = this.querySelector('[data-rn-track]');
        if (!track) return;
        const previous = this.querySelector('[data-rn-prev]');
        const next = this.querySelector('[data-rn-next]');
        const progress = this.querySelector('[data-rn-progress]');
        const sync = () => {
          if (previous) previous.disabled = track.scrollLeft < 4;
          if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          if (progress) progress.style.width = `${Math.min(100,(track.scrollLeft + track.clientWidth) / track.scrollWidth * 100)}%`;
        };
        const move = direction => {
          const card = track.firstElementChild;
          if (!card) return;
          const distance = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
          track.scrollBy({ left:direction * distance, behavior:this._reduced.matches ? 'auto' : 'smooth' });
        };
        previous?.addEventListener('click', () => move(-1), { signal:this._abort.signal });
        next?.addEventListener('click', () => move(1), { signal:this._abort.signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal:this._abort.signal });
        track.addEventListener('scroll', sync, { passive:true, signal:this._abort.signal });
        window.addEventListener('resize', sync, { passive:true, signal:this._abort.signal });
        sync();
      }
      initVideo() {
        const videos = [...this.querySelectorAll('[data-rn-video]')];
        if (!videos.length) return;
        const play = video => {
          if (!video.src) {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.src = window.matchMedia('(max-width: 749px)').matches && video.dataset.mobileSrc ? video.dataset.mobileSrc : video.dataset.src;
          }
          if (this._reduced.matches || navigator.connection?.saveData || video.dataset.autoplay === 'false') {
            video.autoplay = false;
            video.controls = true;
            return;
          }
          video.muted = true;
          const result = video.play();
          result?.catch(() => { video.controls = true; });
        };
        if ('IntersectionObserver' in window) {
          this._videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
            if (entry.isIntersecting && !document.hidden) play(entry.target);
            else entry.target.pause();
          }), { threshold:0.08 });
          videos.forEach(video => this._videoObserver.observe(video));
        } else videos.forEach(play);
        document.addEventListener('visibilitychange', () => videos.forEach(video => {
          if (document.hidden) video.pause();
          else { const rect = video.getBoundingClientRect(); if (rect.bottom > 0 && rect.top < innerHeight) play(video); }
        }), { signal:this._abort.signal });
      }
    }
    customElements.define('rutina-panel', RutinaPanel);
  }
  } catch(e) { console.error(e); }
})();

})();
